import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { fetchVendors } from '../../../../actions/vendor/vendorList'
import { AppState } from '../../../../reducers'
import { VendorListState } from '../../../../reducers/vendor/vendorList'
import { CircularProgress, Stack } from '@mui/material'
import Vendors from '..'
import { useHistory } from 'react-router-dom'
import { LinkedVendorsListState } from '../../../../reducers/person/linkedVendorsList'
import { fetchLinkedVendors } from '../../../../actions/person/linkedVendorsList'
import { FilterTextField, FiltersBar } from '../../../Utils/Filters/Filter'
import { FilterNumber, FilterPersonName } from '../../../Utils/Filters'
import { useTranslation } from 'react-i18next'

interface Props {
  vendorList: VendorListState
  linkedVendors: LinkedVendorsListState
}

const VendorList: React.FC<Props> = ({ vendorList, linkedVendors }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation('vendor')
  const [reading, setReading] = useState<boolean>(true)

  useEffect(() => {
    dispatch(fetchVendors(history.location.search ? history.location.search : '?all=true')) 
    dispatch(fetchLinkedVendors('?all=true'))
    setReading(false)
  }, [dispatch, history.location.search])


  const getLinkedId = () => {
    const urlParams = new URLSearchParams(history.location.search)
    return urlParams.get('id') || ''
  }

  return (
    <>

      <Stack style={{ height: 'calc(100% - var(--header-height)' }}>
        <FiltersBar>
          <FilterNumber style={{ width: '100px' }} name="codigo" label={t("code")} />
          <FilterTextField style={{ width: '350px', maxWidth: '350px' }} name="nombre" label={t("name")} />
          <FilterPersonName label={t('assignedTo')} />
        </FiltersBar>
        {!reading && !vendorList.isFetching && !linkedVendors.isFetching &&
          <Vendors
            rows={(vendorList.vendors || []).map(s => ({ data: s }))}
            linkedVendors={linkedVendors.linkedVendors || []}
            loading={vendorList.isFetching}
            //pagination={vendorList.pagination || undefined}
            onClickInfo={() => { }}
            linkedVendorFilter={getLinkedId()}
          />
        }
      </Stack>
      {(reading || vendorList.isFetching || linkedVendors.isFetching) &&
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <CircularProgress size={25} />
        </div>
      }
    </>
  )
}

const mapStateToProps = (state: AppState) => ({
  vendorList: state.vendorList,
  linkedVendors: state.linkedVendorsList
})

export default connect(mapStateToProps, null)(VendorList)